import gql from 'graphql-tag';
import {surveyOpportunityFragment} from './fragments';

export const saveSurveyOpportunity = gql`
  mutation saveSurveyOpportunity($data: SurveyOpportunityUpdateInput!, $where:  SurveyOpportunityWhereUniqueInput) {
    saveSurveyOpportunity(data: $data, where: $where) ${surveyOpportunityFragment}
  }
`;
